import { sizeOptionsOrDefault } from './utils';
import { MultiPathShape } from './MultiPathShape';
/**
 * Represents a Logical OR shape, used in logic diagrams and circuit diagrams
 * to indicate logical OR operations. Extends MultiPathShape with a circular path
 * and intersecting lines.
 */
export class LogicalOr extends MultiPathShape {
    /**
     * @hidden
     * Draws the logical OR shape path as a circle with horizontal and vertical lines.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const centerX = width / 2;
        const centerY = height / 2;
        const radius = (Math.min(width, height) / 2) - this.options.stroke.width;
        drawingElement
            .moveTo(centerX, 0)
            .arcTo([centerX, height], radius, radius, false, true)
            .arcTo([centerX, 0], radius, radius, false, true)
            .moveTo(0, centerY)
            .lineTo(width, centerY)
            .moveTo(centerX, 0)
            .lineTo(centerX, height);
    }
}
